import {Component, Vue, Watch} from 'vue-property-decorator';
import query from '@/components/query/query-constructor';
import { pushURL } from './utils';
import commonFilter from '@/components/query/commonFilter';
import { mixins } from 'vue-class-component';
import UrlMixin from '@/components/query/url-mixin';

@Component
export default class PickersCache extends mixins(UrlMixin) {

  value: any;
  param: any;
  range: any;
  silent: boolean = false;

  cache(pick: boolean = false, param: any = this.param, value: any = this.value) {
    if(pick) {
      let cacheUrl: any = query.decode(this.$route.params.data as string) || {};
      let cacheStore: any = this.$store.state.dashboard.query;

      this.value = cacheUrl[param] || value || cacheStore[param];
      value = this.value;
    }

    this.$store.commit('dashboardQueryTemporary', {
      name: param,
      value: value
    });

    commonFilter(this);
  }

  pushURL(){
    pushURL(this);
  }

  @Watch('value')
  handle(){
    if (!this.silent)
      this.pushURL();
  }

  @Watch('$route')
  routeChanged(){
    if (!this.silent)
      this.cache();
  }
}
